<template>
  <div class="hello">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <div>
          <span>请填写您的预约信息</span>
        </div>
      </div>
      <div class="box">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="预约事项">
            <el-input v-model="$store.state.project.projectName" disabled></el-input>
          </el-form-item>
          <el-form-item label="预约时间">
            <el-input v-model='$store.state.rule.rDate + " " + $store.state.rule.timeRange' disabled></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="show.userName" placeholder="请输入姓名" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="show.userCardNo" placeholder="请输入证件号" disabled></el-input>
          </el-form-item>
          <el-form-item label="预约手机号">
            <el-input v-model="show.userPhone" placeholder="请输入联系方式" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>

import wasm from "@/mixins/wasm"
import user from "@/mixins/user"
import util from "@/mixins/util";
export default {
  async mounted() {
    await this.initwasm().then(() => {
      this.login()
      this.getUser(res => {
        this.form.userName = res.data.info.name
        this.form.userPhone = res.data.info.phone
        this.form.userCardNo = res.data.info.idNo
        this.form.cardType = res.data.info.idType
        this.show.userName = this.desensitizeName(this.form.userName)
        this.show.userPhone = this.desensitizePhone(this.form.userPhone)
        this.show.userCardNo = this.desensitizeIdCard(this.form.userCardNo)
        this.$store.commit('setUser', this.form)
      })
    })
  },
  mixins: [wasm, user,util],
  data() {
    return {
      form: {
        userName: '',
        userPhone: '',
        userCardNo: '',
        cardType: 10,
        cardTypeName: '身份证'
      },
      show: {
        userName: '',
        userPhone: '',
        userCardNo: '',
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;


  span {
    margin: 0 10px;
  }

  span:nth-child(1) {
    font-weight: 500;
  }

  span:nth-child(3) {
    color: #427AF4;
  }
}

.box {
  width: 500px;
  margin: 0 auto;
  height: 400px;
  ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
